import { render, staticRenderFns } from "./club-detail.vue?vue&type=template&id=dd6828c2&scoped=true&"
import script from "./club-detail.vue?vue&type=script&lang=js&"
export * from "./club-detail.vue?vue&type=script&lang=js&"
import style0 from "./club-detail.vue?vue&type=style&index=0&id=dd6828c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6828c2",
  null
  
)

export default component.exports